/** Audit timestamps are stored in UTC. Display them in US Eastern Time. */

const EASTERN_TIME_ZONE = 'America/New_York';

const NAIVE_UTC_TIMESTAMP =
  /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;

export const parseAuditTimestamp = (iso) => {
  if (iso == null || iso === '') return null;
  const text = String(iso).trim();
  const naive = NAIVE_UTC_TIMESTAMP.exec(text);
  const normalized = naive ? `${naive[1]}T${naive[2]}Z` : text;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatAuditTime = (iso) => {
  const date = parseAuditTimestamp(iso);
  if (!date) return iso ? String(iso) : '—';
  return date.toLocaleString('en-US', {
    timeZone: EASTERN_TIME_ZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
};
